
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/voice-lines",
      function () {
        return require("private-next-pages/docs/voice-lines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/voice-lines"])
      });
    }
  